<template>
    <div id="demo-basic-card" class="margin-top">
        <div id="dashboard-analytics">
            <div class="vx-row">
                <div class="component w-full mt-8">
                    <span class="text-special-info"> {{ $t('overview.numberOfImpressions')}}:
                        <div v-if="!showData" class="lds-facebook">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>     
                    </span>
                    <b-button-group class="group-button ml-2">
                        <vs-button
                            style="border-right: white 1px solid"
                            v-for="(button, indexButton) in optionButtonSelect" :key="indexButton"
                            :style="{height:'40px', background: button.bg}"
                            @click="getPostSelected(button)"
                        >
                            {{button.label}}
                        </vs-button>
                    </b-button-group>
                </div>
                <div class="vx-col p-0 pr-2 md:w-3/12" v-for="(topPost, indexTopic) in listTopPost" :key="indexTopic">
                    <div class="vx-card mt-6 p-6 cart-data-topic w-full">
                        <div class="component min-height-topic">
                            <span 
                                class="badge" 
                                v-for="(group, indexGroup) in optionGroupTopics.filter(group => group.value == topPost.topicGroupId)" 
                                :style="{background: group.bg, color: group.color}" 
                                :key="indexGroup">{{group.label}}</span>
                        </div>

                        <div class="component cursor-pointer" @click="openURL(topPost)">
                            <div class="component mt-4 text-data w-full">
                                <span class="title-top-post">{{topPost.title}}</span>
                            </div>

                            <div class="component mt-2 w-full text-content-keyword">
                                <span class="content-top-post">{{topPost.content}}</span>
                            </div>
                        </div>

                        <div class="component mt-2 w-full mt-2">
                            <span class="text-keyword" >{{ $t('overview.keyword')}}</span>
                        </div>
                        <div class="component min-height-topic">
                            <span class="badge mr-1" style="background: rgba(var(--vs-warning),.15); color: #ff9f43" v-for="(key, indexKeyword) in topPost.keywords" :key="indexKeyword">{{key.keyword}}</span>
                        </div>

                        <div class="component mt-2 w-full mt-4">
                            <span class="text-keyword">{{ $t('overview.shades')}}</span>
                        </div>

                        <div class="component vx-row mt-2">
                            <div class="vx-col md:w-1/3 w-full grid-cls text-center">
                                <feather-icon icon="SmileIcon" class="color-smile m-auto" :style="{color: topPost.colorPositive}"></feather-icon>
                                <span class="ml-2">{{topPost.percentPositive}}%</span>
                            </div>

                            <div class="vx-col md:w-1/3 w-full grid-cls text-center">
                                <feather-icon icon="FrownIcon" class="color-negative m-auto" :style="{color: topPost.colorNegative}"></feather-icon>
                                <span class="ml-2">{{topPost.percentNegative}}%</span>
                            </div>

                            <div class="vx-col md:w-1/3 w-full grid-cls text-center">
                                <feather-icon icon="MehIcon" class="color-neutral m-auto" :style="{color: topPost.colorNeutral}"></feather-icon>
                                <span class="ml-2">{{topPost.percentNeutral}}%</span>
                            </div>
                        </div>

                        <div class="component vx-row mt-6">
                            <div class="vx-col md:w-1/3 w-full p-0 pr-1 mt-2">
                                <div class="w-full component badge sub-component-info " style="background: rgba(var(--vs-dark),.1); color: #F8F8F8">
                                    <span class="text-sub-component-info">Tương tác</span>
                                    <b class="count-sub-component-info mt-2">{{ eArabic(topPost.interactive) || 0}}</b>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/3 w-full p-0 pr-1 mt-2">
                                <div class="w-full component badge sub-component-info " style="background: rgba(var(--vs-dark),.1); color: #F8F8F8">
                                    <span class="text-sub-component-info">Bình luận</span>
                                    <b class="count-sub-component-info mt-2">{{ eArabic(topPost.comment) || 0}}</b>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/3 w-full p-0 mt-2">
                                <div class="w-full component badge sub-component-info " style="background: rgba(var(--vs-dark),.1); color: #F8F8F8">
                                    <span class="text-sub-component-info">Chia sẻ</span>
                                    <b class="count-sub-component-info mt-2">{{ eArabic(topPost.share) || 0}}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full mt-4 text-center">
                    <vs-button type='flat' @click="addRecord">{{ $t('hashtag.seeMore') }}</vs-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { BButtonGroup, BButton, BCardText } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
export default {
    components: {
        BButtonGroup,
        BButton,
        BCardText,
    },
    directives: {
        Ripple
    },
    data(){
        return {
            showData: false,
            //value button
            countDataResponse: null,
            optionButtonSelect: [
                {label: '10', id: 1, value: 10, bg: '#2F80ED'},
                {label: '25', id: 2, value: 25, bg: '#2F80ED'},
                {label: '50', id: 3, value: 50, bg: '#2F80ED'}
            ],
            numberOfDisplayPosts: 10,
            addRecordPages: 0,
            numberOfPage: 0,
            //group
            optionGroupTopics: [],
            //topic
            listTopPost: [],
            optionTopics: [],
            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                    let date = new Date();
                    date.setDate(date.getDate() - 29);
                    date.setHours(0, 0, 0);
                    return date
                })()
            },
        }
    },
    methods: {
        refreshData: function() {
            let fromDate = this.dateRange.startDate;
            let toDate = this.dateRange.endDate;
            if (this.numberOfDisplayPosts > this.countDataResponse) {
                this.numberOfDisplayPosts = this.countDataResponse;
            }
            let conditions = {
                from: fromDate,
                to: toDate,
                topicId: this.topicId,
                groupId: this.topicGroupId,
                beanTypeSocial: [],
                pageSize: this.numberOfDisplayPosts
            };
            this.getTopPostByClassification(conditions);
        },
        initScreen(){
            this.refreshData();
        },
        getTopicGroups: function(){
            return new Promise((resolve,reject) =>{
                this.$business.post('/topic-group/find-by-conditions',{}).then((res) =>{
                this.optionGroupTopics = res.data;
                if(this.optionGroupTopics.length > 0){
                    this.optionGroupTopics = this.optionGroupTopics.map(el =>{
                    let background = el.color ? this.hexToRgbA(el.color) : this.hexToRgbA('#007AFE')
                    return {
                        label:el.groupName,
                        value:el.id,
                        color: el.color ? el.color : '#007AFE',
                        bg: background
                    }
                    })
                    let selecteAll = {label: 'Tất cả', value: null, color: '#007AFE', bg: background}
                    this.optionGroupTopics.unshift({label: 'Khác', value: null, color: '#007AFE', bg: background})
                    this.optionGroupTopics.sort(function(a ,b){
                    return b.value - a.value;
                    })
                    this.optionGroupTopics = [selecteAll].concat(this.optionGroupTopics);
                    resolve();
                }
            }).catch(() => reject())
            })
        },
        openURL: function(post){
            window.open(post.url, '_blank');
        },
        getTopPostByClassification: function(payload){
            this.$vs.loading()
            this.$processor.post('/user-data/get-top-classification', payload).then((response) => {
                this.$vs.loading.close()
                this.countDataResponse =  response.data.length;
                let index = 0;
                let result = response.data.map(el => {
                    let totalClassification = el.positive + el.negative + el.normal;
                    let contennt = el.fullContents.filter(item => item.type == "text").map(text => {
                        if (text.content){
                           return text.content.trim();
                        }
                    }).join('\n')

                    let object = {};
                    object['stt'] = index++;
                    object['title']= el.title;
                    object['content'] = contennt;
                    object['value'] = totalClassification;
                    object['topicId'] = el.topicId;
                    object['keywords']= el.keywords;
                    object['interactive'] = el.specialFields.reactionCount;
                    object['share']  = el.specialFields.shareCount;
                    object['comment'] = el.specialFields.commentCount;
                    object['topicGroupId'] = el.topicGroupId;
                    object['url'] = el.url
                    let percentPost = 0;
                    
                    percentPost = ((el.positive / totalClassification) * 100).toFixed(0);
                    object['percentPositive'] = !isNaN(percentPost) ? parseInt(percentPost) : 0;
                    percentPost = ((el.normal / totalClassification) * 100).toFixed(0);
                    object['percentNeutral'] = !isNaN(percentPost) ? parseInt(percentPost) : 0;
                    percentPost = ((el.negative / totalClassification) * 100).toFixed(0);
                    object['percentNegative'] = !isNaN(percentPost) ? parseInt(percentPost) : 0;
                    if (el.positive > el.normal && el.positive > el.negative){
                        object['colorPositive'] = '#007AFE';
                        object['colorNegative'] = "#B9B9C3";
                        object['colorNeutral'] = '#B9B9C3';
                    }
                    if (el.normal > el.positive && el.normal > el.negative){
                        object['colorPositive'] = '#B9B9C3';
                        object['colorNegative'] = "#B9B9C3";
                        object['colorNeutral'] = '#FEC400';
                    }
                    if (el.negative > el.positive && el.negative > el.normal){
                        object['colorPositive'] = '#B9B9C3';
                        object['colorNegative'] = "#F12B2C";
                        object['colorNeutral'] = '#B9B9C3';
                    }
                    if (el.positive == el.negative && el.positive == el.neutral) {
                        object['colorPositive'] = '#007AFE';
                        object['colorNegative'] = "#FEC400";
                        object['colorNeutral'] = '#F12B2C';
                    }
                    return object;
                })
                this.listTopPost = result;
                this.optionTopics = result;
                this.showData = true;
            })
        },
        addRecord: function(){
            if (this.numberOfPage == 10) this.addRecordPages += 10;
            if (this.numberOfPage == 25) this.addRecordPages += 25;
            if (this.numberOfPage == 50) this.addRecordPages += 50;
            this.numberOfDisplayPosts = this.addRecordPages
            this.refreshData();
        },
        getPostSelected: function(item){
            this.optionButtonSelect.forEach(el => el.bg = '#2F80ED !important')
            item.bg = "#1561C3 !important"
            this.listTopPost = this.optionTopics;
            this.numberOfDisplayPosts = item.value;
            this.addRecordPages = item.value;
            this.numberOfPage = item.value;
            this.refreshData()

        },
        hexToRgbA:function(hex){
            var c;
            if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                c= hex.substring(1).split('');
                if(c.length== 3){
                    c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                }
                c= '0x'+c.join('');
                return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+', .15)';
            }
            throw new Error('Bad Hex');
        },
        eArabic: function(x) {
            return x ? x.toLocaleString("de-DE") : 0;
        },
    },
    async created(){
        this.getTopicGroups();
        this.initScreen();
    }
}
</script>
<style lang="scss">
.title-top-post {
    height: 54px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.content-top-post{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.count-sub-component-info {
    font-size: 14px;
    color: #5E5873;
}
.text-sub-component-info {
    font-size: 14px;
    color: #5E5873;
}
.sub-component-info {
    display: grid !important;
    min-width: 70px;
    height: 50px;
} 
.badge {
    padding: .3rem .5rem;
    text-align: center;
    border-radius: .358rem;
    font-weight: 400 !important;
}
.text-special-info{
    font-size: 14px;
    color: #5E5873;
}
.margin-top{
    margin-top: -38px;
}
.text-keyword {
    font-size: 12px;
    color: #B9B9C3;
}
.text-data {
    font-size: 18px;
    color: #5E5873;
}
.color-smile {
    // color: #007AFE;
    vertical-align: middle;
}
.color-negative {
    // color: #EA5455;
    vertical-align: middle;
}
.color-neutral {
    // color: #FEC400;
    vertical-align: middle;
}
.component svg {
    width: 30px;
    height: 30px;
}
.grid-cls {
    display: grid;
}
.group-button {
    display: -webkit-inline-box;
}
.min-height-topic {
    min-height: 42px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.text-content-keyword {
    font-size: 12px;
    color: #6E6B7B;
    min-height: 36px;
    
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;
  float: revert;
  padding-left: 25px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}

.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -0.24s;
}

.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -0.12s;
}

.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px;
  }

  50%,
  100% {
    top: 16px;
    height: 4px;
  }
}
</style>